import "./scss/custom.scss";

document.addEventListener("DOMContentLoaded", () => {
    const req = new XMLHttpRequest();
    req.open("PUT", "/api/auth/ua");
    req.send('{"href":"' + window.location.href + '"}');
});
